import { render, staticRenderFns } from "./InlineNotification.vue?vue&type=template&id=900687c6&scoped=true&"
import script from "./InlineNotification.vue?vue&type=script&lang=ts&"
export * from "./InlineNotification.vue?vue&type=script&lang=ts&"
import style0 from "./InlineNotification.vue?vue&type=style&index=0&id=900687c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900687c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCheckCircle24px: require('/var/www/packages/theme/components/icons/check-circle/CheckCircle24px.vue').default,IconsCrossCircle24px: require('/var/www/packages/theme/components/icons/cross-circle/CrossCircle24px.vue').default,IconsInfoCircle24px: require('/var/www/packages/theme/components/icons/info-circle/InfoCircle24px.vue').default,AtomsMarkdownRender: require('/var/www/packages/theme/components/atoms/MarkdownRender.vue').default,AtomsCloseButton: require('/var/www/packages/theme/components/atoms/CloseButton.vue').default})
